import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../base-query';

export interface OnboardingChecklistStep {
  completed: boolean;
  credits_reward: number;
  reward_available: boolean;
}

export interface OnboardingChecklistStatus {
  extension_installed: OnboardingChecklistStep;
  lead_enriched: OnboardingChecklistStep;
  lead_saved_to_list: OnboardingChecklistStep;
  agent_run: OnboardingChecklistStep;
  eligible_for_onboarding_bonus: boolean;
  onboarding_bonus_claimed: boolean;
  all_steps_completed_at: string | null;
  checklist_viewed: boolean;
}

export const onboardingChecklistApi = createApi({
  reducerPath: 'onboardingChecklistApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['OnboardingChecklist'],
  endpoints: (builder) => ({
    getOnboardingChecklist: builder.query<OnboardingChecklistStatus, void>({
      query: () => '/onboarding/checklist',
      providesTags: ['OnboardingChecklist'],
    }),
  }),
});

export const { useGetOnboardingChecklistQuery } = onboardingChecklistApi;
